import React, {FC} from 'react'

interface IPaystubAdviceInfoProps {
	adviceNumber?: string
	paymentDay: string
	employeeSocial?: string
	className?: string
}

const PaystubAdviceInfo: FC<IPaystubAdviceInfoProps> = ({
	adviceNumber,
	paymentDay,
	employeeSocial,
	className = '',
}) => {
	return (
		<table className={`advice-info ${className}`}>
			<tbody>
				<tr>
					<th>Advice Number:</th>
					<td>{adviceNumber}</td>
				</tr>
				<tr>
					<th className="fw-normal">Pay Date:</th>
					<td>{paymentDay}</td>
				</tr>
				{employeeSocial && (
					<tr>
						<th className="fw-normal">Social Security Number:</th>
						<td>{employeeSocial}</td>
					</tr>
				)}
			</tbody>
		</table>
	)
}

PaystubAdviceInfo.displayName = 'PaystubAdviceInfo'

export default PaystubAdviceInfo
